import api from '@/utils/http'

const BASE_PATH = '/v4/tracking-databoard'

function ensureSuccess(response, fallbackMessage) {
  if (!response || response.code !== 200 || response.success === false) {
    throw new Error(response?.message || response?.errorMsg || fallbackMessage)
  }
  return response.data
}

export async function fetchProjectList(params = {}) {
  const data = await api.post(`${BASE_PATH}/api/project/pageQuery`, {
    name: params.name || '',
    page: params.page || 1,
    size: params.size || 50,
    sortField: params.sortField || 'id',
    sortOrder: params.sortOrder || 'desc'
  })
  return ensureSuccess(data, '获取项目列表失败')
}

/** 按 project_code 解析 projectId（导出记录重跑等场景） */
export async function resolveProjectIdByCode(projectCode) {
  const code = String(projectCode || '').trim()
  if (!code) return null
  const result = await fetchProjectList({ name: code, page: 1, size: 100 })
  const list = result?.list || []
  const matched = list.find((item) => item.code === code)
  return matched?.id ?? null
}

export async function fetchChannelList(params) {
  const data = await api.post(`${BASE_PATH}/api/module/custom/channelList`, params)
  return ensureSuccess(data, '获取渠道列表失败')
}

export async function fetchBasicMain(params) {
  const data = await api.post(`${BASE_PATH}/api/module/basic/main`, params)
  return ensureSuccess(data, '获取流量主数据失败')
}

export async function fetchBehaviorList(params) {
  const data = await api.post(`${BASE_PATH}/api/module/custom/behaviorList`, {
    channel: '',
    indexName: '',
    ...params
  })
  return ensureSuccess(data, '获取行为数据失败')
}

export async function fetchBehaviorDetail(params) {
  const data = await api.post(`${BASE_PATH}/api/module/custom/main`, params)
  return ensureSuccess(data, '获取行为按天数据失败')
}
